import { useContext } from "react"
import { PrescriptionDataContext } from "../context/PrescriptionDataContext"

const ClientLabel = ({client_id}) => {
    // context
    const {labelIdMap} =  useContext(PrescriptionDataContext);
    
    return (
        <span>{Object.keys(labelIdMap).includes(String(client_id)) ? labelIdMap[client_id] : client_id}</span>
    )
}

export default ClientLabel